/**
 * Trim filters: remove empty-string values
 * @param {object} filters - The filters object, ex: {name:'', status: ['CREATED','ACTIVATED'], type:[]}
 * @returns {object} - The trimed filters object, ex: {status: ['CREATED','ACTIVATED'], type:[]}
 */
export function trimFilters(filters) {
  const nonEmptyFilters = {};
  if (filters) {
    Object.keys(filters).forEach((key) => {
      if (filters[key] !== '' && filters[key] !== null) {
        nonEmptyFilters[key] = filters[key];
      }
    });
  }
  return nonEmptyFilters;
}

/**
 * Serialize Filters object, to be used as query string parameters
 * @param {object} filters - The filters object, ex: {status: ['CREATED','ACTIVATED'], product_type:['PHOTO']}
 * @return {string} - The serialized urlized filters, ex: `filter[product_type]=PHOTO&filter[status]=CREATED%2CACTIVATED`
 */
export function serializeFilters(filters) {
  const serialized = [];
  Object.keys(filters)
    .sort()
    .forEach((key) => serialized.push(
      `filter[${encodeURIComponent(key)}]=${encodeURIComponent(filters[key])}`,
    ));
  return serialized.join('&');
}
